export default __webpack_public_path__ + "static/1210-ee0eadb6672da5920dd57a2f0d66ec53.gif";